import { render, staticRenderFns } from "./TaxOrder.vue?vue&type=template&id=b1e2dec2&"
import script from "./TaxOrder.vue?vue&type=script&lang=js&"
export * from "./TaxOrder.vue?vue&type=script&lang=js&"
import style0 from "./TaxOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports